import React from 'react';

interface Props {
  label: string;
  value: number | string;
  accent: 'blue' | 'green' | 'purple' | 'orange' | 'cyan';
  icon?: string;
  suffix?: string;
}

/**
 * Tarjeta numérica genérica. Estilo tipo badge circular de ícono arriba +
 * número grande + label -- inspirado en la referencia visual compartida
 * (Page Views / Visitors / Click / Orders del dashboard Shopeers).
 * `accent` colorea el fondo del badge (tinte suave), no un borde lateral.
 */
const KpiCard = ({ label, value, accent, icon, suffix }: Props) => {
  return (
    <div className={`kpi-card accent-${accent}`}>
      {icon && (
        <div className='icon-badge'>
          <img src={icon} alt='' />
        </div>
      )}
      <div className='content'>
        <p className='value'>
          {value}
          {suffix && <span className='suffix'>{suffix}</span>}
        </p>
        <p className='label'>{label}</p>
      </div>
    </div>
  );
};

export default KpiCard;
